module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/3a0dbd15df9deb7c102c4280b772fa26.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/legend.png
// module id = S3ak
// module chunks = 0